<template>
  <o-tooltip :label="displayName" multiline>
    <div
      class="project-name-column is-link truncate"
      :style="{ '--project-name-column-max-width': `${maxWidth}px` }"
      @click="handleClick"
    >
      {{ displayName }}
    </div>
  </o-tooltip>
</template>

<script setup lang="ts">
  import {computed, toRefs} from 'vue';

  const props = withDefaults(defineProps<{
    row: {
      bid_phase_name?: string | null,
    },
    value?: string | null,
    maxWidth?: number,
  }>(), {
    value: '',
    maxWidth: 260,
  });

  const {row, value, maxWidth} = toRefs(props);

  const displayName = computed(() => {
    const projectName = value.value?.trim() ?? '';
    const bidPhaseName = row.value.bid_phase_name?.trim();

    return bidPhaseName ? `${projectName} (${bidPhaseName})` : projectName;
  });

  const emit = defineEmits<{
    'click': [unknown],
  }>();

  function handleClick() {
    emit('click', row.value);
  }
</script>

<style scoped lang="scss">
  .project-name-column {
    max-width: var(--project-name-column-max-width);
  }
</style>
